import { DatepickerRange, RangeDatepickerComponent } from '@ui/aos-lib';
import {
  FilterModel,
  SearchType
} from '../../../../shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { SEARCH_HINTS } from '../../../../shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { TranslateRegistry } from '../../../../services/translate/translate.registry';
import { DateUtil } from '@portal/shared/utils/date-util';
import { MissingProgrammingRecordsFieldName } from './missing-programming-records.types';

export const MISSING_PROGRAMMING_RECORDS_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [MissingProgrammingRecordsFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.Search
  }
];

export const MISSING_PROGRAMMING_RECORDS_DEFAULT_SEARCH_TYPE = MISSING_PROGRAMMING_RECORDS_SEARCH_TYPES[0];

export const MISSING_PROGRAMMING_RECORDS_SORT_FIELD: Record<string, MissingProgrammingRecordsFieldName> = {
  commDeviceId: MissingProgrammingRecordsFieldName.CommDeviceId,
  initialTransmissionTime: MissingProgrammingRecordsFieldName.InitialTransmissionTime,
  lastTransmissionTime: MissingProgrammingRecordsFieldName.LastTransmissionTime
};

export const MISSING_PROGRAMMING_RECORDS_DATE_TIME: FilterModel = {
  items: [],
  selected: [],
  width: 0,
  filterType: MissingProgrammingRecordsFieldName.DateTimeUTC,
  title: TranslateRegistry.get.FILTER.TITLE.INITIAL_TRANSMISSION_TIME,
  isDatepicker: true,
  minDate: null,
  maxRangeDays: 365,
  dateRange: () => [
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
  ],
  defaultDateRange: () => [
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
    DateUtil.toISOString((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
  ]
};
